import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Request from "../../components/api/Request";
import { Button } from "devextreme-react/button";
import TextBox from "devextreme-react/text-box";
import { CheckBox } from 'devextreme-react/check-box';
import { Popup } from 'devextreme-react/popup';
import TesvikSgkLogin from "./TesvikSgkLogin";
import * as AppActions from '../../actions/AppActions';
import { showDialog } from "../../utils/Utils";

const TesvikLoginIslemleri = (props) => {
  const dispatch = useDispatch();

  let donem = props.data.donemAdiList.join(" - ");
  const [dataInfo, setDataInfo] = useState({
    donemAdi: "",
    domainId: props.data.domainId,
    domainAdi: props.data.domainAdi,
    donemIdList:props.data.donemIdList,
    donemAdiList:props.data.donemAdiList,
    donem: donem,
    onayliIndir: false,
    tumPersonelleriSorgula: false,
    isverenSistemLogin: false,
    issizlikSistemLogin: false,
    isbasiSistemLogin: false,
    bildirgeSistemiLogin: false,
    tesvikKanalSayisi :1,
    tesvikKanalSiradakiLoginOlmamis:1
  });

  const [loginData, setLoginData] = useState({ popupState: false, data: {} });

  useEffect(() => {
    if (props.data.islem != 'indir' && props.data.islem != 'kaydet' && props.data.islem != 'login') {
      props.hide();
    }
    setButtonState();

  }, []);

  function setButtonState() {

    dispatch(AppActions.setLoading(true, "Teşvik servisi login bilgileri alınıyor.."));
    const request = new Request("/tesvikIslemleri/isLogin/" + props.data.domainId, "GET");
    request.run()
      .then(response => {
        if (response.data.success == true) {
          setDataInfo(Object.assign({}, dataInfo, {
            isverenSistemLogin: response.data.data.isveren,
            issizlikSistemLogin: response.data.data.issizlik,
            isbasiSistemLogin: response.data.data.isbasi,
            bildirgeSistemiLogin: response.data.data.bildirge,
            tesvikKanalSayisi: response.data.data.tesvikKanalSayisi,
            tesvikKanalSiradakiLoginOlmamis: response.data.data.tesvikKanalSiradakiLoginOlmamis,
          }));

          if(props.data.islem == 'login' ){
            if(response.data.data.isveren  && response.data.data.issizlik && response.data.data.isbasi  && response.data.data.bildirge){
              dispatch(AppActions.setLoading(false, ""));
              props.hide();
            }
          }
        }
        dispatch(AppActions.setLoading(false, ""));

      })
      .catch(() => {
        dispatch(AppActions.setLoading(false, ""));
      });
  }


  function onOnayliValueChanged(args) {
    setDataInfo(Object.assign({}, dataInfo, { onayliIndir: args.value }));
  }
  function onTumpersonelleriSorgulaValueChanged(args) {
    setDataInfo(Object.assign({}, dataInfo, { tumPersonelleriSorgula: args.value }));
  }

  function hideTesvikIslemleriPopup() {
    setLoginData({ popupState: false, data: {} })
    setButtonState();
  }
  function showIsverenLoginPopup() {
    setLoginData({
      popupState: true,
      data: { domainId: props.data.domainId, sistem: "isveren" }
    });
  }
  function showIssizlikLoginPopup() {
    setLoginData({
      popupState: true,
      data: { domainId: props.data.domainId, sistem: "issizlik" }
    });
  }
  function showIsbasLoginPopup() {
    setLoginData({
      popupState: true,
      data: { domainId: props.data.domainId, sistem: "isbasi" }
    });
  }

  function showBildirgeLoginPopup() {
    setLoginData({
      popupState: true,
      data: { domainId: props.data.domainId, sistem: "bildirge" }
    });
  }



  function donemIslemBaslat() {
    //debugger;
    //dataInfo.onayliIndir = !dataInfo.onayliIndir;
    if(props.data.islem == 'indir' ){ //dönem indir
      onayliDonemVeTumPersonelleriSorgula(dataInfo.onayliIndir, dataInfo.tumPersonelleriSorgula);
    }else if(props.data.islem == 'kaydet' ){ //dönem kaydet
      donemKaydet(dataInfo.domainId,dataInfo.donemIdList,dataInfo.donemAdiList,0);
    }

  }

  function onayliDonemVeTumPersonelleriSorgula(onayliDonem,tumPersonelleriSorgula) {
    if(onayliDonem == true){
      dispatch(AppActions.setLoading(true, "Onaylı Dönem İndiriliyor.."));
      const request = new Request("/tesvikIslemleri/onayliDonemIndir/" + dataInfo.domainId ,"GET");
      request.run().then((response) => {

        dispatch(AppActions.setLoading(false, ""));
        if (response && response.data && response.data.data === true) {
            //props.hide();
            onayliDonemVeTumPersonelleriSorgula(false,tumPersonelleriSorgula);
        }
      });
    }else if(tumPersonelleriSorgula == true){
      dispatch(AppActions.setLoading(true, "Tüm Personeller Sorgulanıyor(Engelli,İşbaşı Eğitimi).."));
      const request = new Request("/tesvikIslemleri/tumPersonelSorgula/" + dataInfo.domainId ,"GET");
      request.run().then((response) => {

        dispatch(AppActions.setLoading(false, ""));
        if (response && response.data && response.data.data === true) {
            //props.hide();
            onayliDonemVeTumPersonelleriSorgula(onayliDonem,false);
        }
      });
    }else{
      donemIndir(dataInfo.domainId,dataInfo.donemIdList,dataInfo.donemAdiList,0);
    }
  }


  function donemIndir(domainId,donemIdList,donemAdiList,index) {
    //debugger;
    //dataInfo.onayliIndir = !dataInfo.onayliIndir;
    if (donemIdList.length > index) {
      let donemId = donemIdList[index];
      let donemAdi = donemAdiList[index];

      let mesaj ="(" +  (index+1) + "/" +donemIdList.length +")  " + donemAdi +" Dönemi indiriliyor ";

      dispatch(AppActions.setLoading(true, mesaj));
      
      const request = new Request("/tesvikIslemleri/donemIndir/" + dataInfo.domainId + "/" + donemId, "GET");
      request.run().then((response) => {
        //debugger;
        dispatch(AppActions.setLoading(false, ""));
        if (response && response.data && response.data.data === true) {
          index++;
          donemIndir(domainId,donemIdList,donemAdiList,index);
        }else if(response && response.response && response.response.data ){
          let message  =response.response.data.message;
          showDialog({ title: 'Dönem Hata', message: message, buttons: "OK" });
        }
      }).catch((error) => {
        dispatch(AppActions.setLoading(false, ""));

      });;
    }else{
       props.hide();
    }
  }
  function donemKaydet(domainId,donemIdList,donemAdiList,index) {
    //debugger;
    //dataInfo.onayliIndir = !dataInfo.onayliIndir;
    if (donemIdList.length > index) {
      let donemId = donemIdList[index];
      let donemAdi = donemAdiList[index];

      let mesaj ="(" +  (index+1) + "/" +donemIdList.length +")  " + donemAdi +" Dönemi Onaylanıyor";

      dispatch(AppActions.setLoading(true, mesaj));

      const request = new Request("/tesvikIslemleri/saveTesvikSgk/" + dataInfo.domainId + "/" + donemId, "GET");
      request.run().then((response) => {
        //debugger;
        dispatch(AppActions.setLoading(false, ""));
        if (response && response.data && response.data.data === true) {
          index++;
          donemKaydet(domainId,donemIdList,donemAdiList,index);
        }
      }).catch((error) => {
        dispatch(AppActions.setLoading(false, ""));
      });;
    }else{
       props.hide();
    }
  }
  return (
    <React.Fragment>

      <TextBox readOnly={true} hoverStateEnabled={false} value={dataInfo.domainAdi}
          visible={props.data.islem != 'login' }  />
      <br></br>
      <TextBox readOnly={true} hoverStateEnabled={false} value={dataInfo.donem}
          visible={props.data.islem != 'login' }  />
      <br></br>
      <CheckBox value={dataInfo.onayliIndir} width={300} text="Tüm Onaylanmışları indir" onValueChanged={onOnayliValueChanged}
          visible={props.data.islem == 'indir' } />

      <CheckBox value={dataInfo.tumPersonelleriSorgula} width={300} text="Tüm Personelleri Sorgula(Engelli,İşbaşı Eğitimi)" onValueChanged={onTumpersonelleriSorgulaValueChanged}
          visible={props.data.islem == 'indir' } />
      <br></br>

      <Button width={300} text={"İşveren Sistemi Giriş (" + dataInfo.tesvikKanalSiradakiLoginOlmamis + "/" + dataInfo.tesvikKanalSayisi+")"}   type="danger" stylingMode="contained"
          visible={!dataInfo.isverenSistemLogin}
          onClick={showIsverenLoginPopup}
      />
      <Button width={300} text="İssizlik Sistemi Giriş" type="danger" stylingMode="contained"
        visible={!dataInfo.issizlikSistemLogin}
        onClick={showIssizlikLoginPopup}
      />
      <Button width={300} text="İşbaşı Sistemi Giriş" type="danger" stylingMode="contained"
        visible={!dataInfo.isbasiSistemLogin}
        onClick={showIsbasLoginPopup}
      />
      <Button width={300} text="Bildirge Sistemi Giriş" type="danger" stylingMode="contained"
              visible={!dataInfo.bildirgeSistemiLogin}
              onClick={showBildirgeLoginPopup}
      />

      <br></br>
      <Button
        width={300}
        text={props.data.islem == 'indir' ? "Dönem indir" : "Dönem Kaydet"}
        type="success"
        stylingMode="contained"
        visible={dataInfo.isverenSistemLogin && dataInfo.issizlikSistemLogin && dataInfo.isbasiSistemLogin && dataInfo.bildirgeSistemiLogin && props.data.islem != 'login' }
        onClick={donemIslemBaslat}
      />


      <Popup
        visible={loginData.popupState}
        onHiding={hideTesvikIslemleriPopup}
        dragEnabled={false}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Sgk Login işlemleri"
        width={300}
        height={200}
      >
        <div>
          {loginData.popupState ? <TesvikSgkLogin data={loginData.data} hide={hideTesvikIslemleriPopup} /> : null}
        </div>
      </Popup>

    </React.Fragment>
  );
};

export default TesvikLoginIslemleri;

